import { IMG_AIRPORT_PEOPLE } from '@repo/assets';
import styled from 'styled-components';
import {
  ICON_EDIT_CARD,
  ICON_RECEIVING_FUNDS,
  ICON_PROTECTION,
} from '@repo/assets';

type Props = {
  nationality: string;
};

export const AirportNonRefundableMessage = ({ nationality }: Props) => {
  const nationIndex = nationality === 'KOR' ? 1 : 0;
  const text = {
    line1: ['Don’t wait in line anymore.', '이제 줄 서지 마세요.'],
    line2: [
      'We’ll send your refund directly to your bank account.',
      '환급금을 계좌로 송금해드릴게요!',
    ],
    description: [
      'After visit customs, we’ll transfer your refund to your account.',
      '세관만 방문하시면 계좌로 환급금을 송금해드려요.',
    ],
    step1: ['Enter account information', '계좌정보 입력'],
    step2: ['Visit customs', '세관 방문'],
    step3: ['Transfer to your account', '환급금 계좌로 송금'],
    description2: [
      `*If you depart from an airport other than Incheon,\nkiosk refunds are not available.`,
      '*인천공항 외 지역에서 출국시 공항 키오스크 환급이 안됩니다',
    ],
  };

  return (
    <Wrapper>
      <PeopleIcon src={IMG_AIRPORT_PEOPLE} alt='' />
      <Title>
        {text.line1[nationIndex]}
        <br />
        {text.line2[nationIndex]}
      </Title>
      <Description>{text.description[nationIndex]}</Description>
      <StepList>
        <StepItem>
          <Number>1</Number>
          <Text>
            {text.step1[nationIndex]}
            <img src={ICON_EDIT_CARD} alt='' />
          </Text>
        </StepItem>
        <StepItem>
          <Number>2</Number>
          <Text>
            {text.step2[nationIndex]}
            <img src={ICON_PROTECTION} alt='' />
          </Text>
        </StepItem>
        <StepItem>
          <Number>3</Number>
          <Text>
            {text.step3[nationIndex]}
            <img src={ICON_RECEIVING_FUNDS} alt='' />
          </Text>
        </StepItem>
      </StepList>
      <SubDescription>{text.description2[nationIndex]}</SubDescription>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: calc(100% - 96px - 44px); // footer, prev-button
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  overflow-y: auto;
  margin-bottom: calc(96px + 16px); // footer, gap

  &::-webkit-scrollbar {
    display: none;
  }
`;

const PeopleIcon = styled.img`
  width: 245px;
  margin: 16px 0;
`;

const Title = styled.strong`
  color: #111;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 12px;
`;

const Description = styled.p`
  color: #777;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 40px;
`;

const SubDescription = styled.p`
  color: #999;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  white-space: pre-line;
`;

const StepList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 52px;
  width: 100%;
  padding: 0 40px;
  margin-bottom: 24px;
`;

const Number = styled.span`
  position: relative;
  background-color: #e9f0fe;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #246cf6;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
`;

const StepItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  &:is(:nth-child(1), :nth-child(2)) ${Number}::after {
    content: '';
    width: 2px;
    height: 40px;
    background-color: #f4f4f4;
    position: absolute;
    top: calc(24px + 6px); // Number-height, gap
  }
`;

const Text = styled.span`
  display: inline-flex;
  gap: 8px;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;

  img {
    width: 20px;
    height: 20px;
  }
`;
